import axios from '@/lib/axios';

export interface Banner {
  _id?: string;
  title: string;
  content: string;
  displayType: 'banner' | 'news' | 'modal';
  backgroundColor: string;
  textColor: string;
  buttonText?: string;
  buttonLink?: string;
  iconSvg?: string;
  startDate: string;
  endDate: string;
  targetCompanies: string[]; // Company IDs
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export const bannerService = {
  // Get all banners with pagination
  async getBanners(page: number = 1, limit: number = 20) {
    const { data } = await axios.get('/banners', {
      params: { page, limit }
    });
    return data;
  },

  // Get banner by ID
  async getBannerById(id: string) {
    const { data } = await axios.get(`/banners/${id}`);
    return data;
  },

  // Create new banner
  async createBanner(banner: Omit<Banner, '_id'>) {
    const { data } = await axios.post('/banners', banner);
    return data;
  },

  // Update banner
  async updateBanner(id: string, banner: Partial<Banner>) {
    const { data } = await axios.put(`/banners/${id}`, banner);
    return data;
  },

  // Delete banner
  async deleteBanner(id: string) {
    const { data } = await axios.delete(`/banners/${id}`);
    return data;
  },

  // Activate banner
  async activateBanner(id: string) {
    const { data } = await axios.patch(`/banners/${id}/activate`, {});
    return data;
  },

  // Deactivate banner
  async deactivateBanner(id: string) {
    const { data } = await axios.patch(`/banners/${id}/deactivate`, {});
    return data;
  }
};
